import Swiper from "swiper";
import {
    Navigation, Pagination, Autoplay, EffectFade,
    Keyboard,
    Mousewheel,
    Scrollbar } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import "swiper/css/scrollbar";
//import "swiper/css/lazy";

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import "aos/dist/aos.css";
import AOS from "aos";

import Cookies from "js-cookie";
import { createApp, reactive } from 'petite-vue';

//import ReadSmore from "read-smore";
import ReadSmore from "../scripts/readmore/readmore.umd.js";
import "../scripts/header.js";

import 'vanilla-match-height';

import { Hls } from 'hls.js';

//import "../scripts/vanillavalidation/vanilla-validator.concat.min.js";
//import { VanillaValidator } from "vanilla-validation";

//const VanillaValidator = new window.VanillaValidator;

//import flatpickr from "flatpickr";
//import rangePlugin from "flatpickr/dist/plugins/rangePlugin";
//import { German } from "flatpickr/dist/l10n/de";
//import { Italian } from "flatpickr/dist/l10n/it";
//import "flatpickr/dist/flatpickr.css";

//import JustValidate from 'just-validate';
//'assets/scripts/axios/axios.min.js',
//'assets/scripts/enquiry.js'

//import axios from "axios";

//import { jarallax, jarallaxVideo } from "jarallax";
//import 'jarallax/dist/jarallax.min.css';

// ================= Global Variables
var containers = null;
var iframecontainer = null;
var containersSum = [];
var sizes = [180, 240, 360, 480, 640, 800, 1024, 1200, 1600, 2048],
    urlRegex = new RegExp('[\(\'\"]([^\'\"\)]+)', 'i'),
    parameterRegex = new RegExp('([^=&]+)=([^&]*)', 'ig');

var threshold = 50;
var parallaxcontainer = null;
var mobilenav = 1200;
var packagesswipers = null;
var teasersswiper = null;
var bgimageScale = 2;
var bgimageWebpQuality = 42;
var bgimageJpegQuality = 42;
var headerslider = null;
var players = [];
var currentEnquiryRequest = false;
var youtubeApiPromise = null;
var vimeoApiPromise = null;

// =======================================

// ================== Global Functions
//function onYouTubeIframeAPIReady() {
//    document.querySelectorAll('.headerslider .youtube .embed-player').forEach(function (that) {

//    });
//}

function consolelog(message) {
    if (website.debug == true) {
        try {
            console.log(message);
        } catch (ex) {
        }
    }
}

function loadExternalScript(src, isReady) {
    if (isReady()) return Promise.resolve();
    return new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[src="' + src + '"]');
        if (existing) {
            existing.addEventListener('load', resolve, { once: true });
            existing.addEventListener('error', reject, { once: true });
            return;
        }
        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
    });
}

function loadVimeoApi() {
    if (!vimeoApiPromise) {
        vimeoApiPromise = loadExternalScript('https://player.vimeo.com/api/player.js', function () {
            return typeof window.Vimeo !== 'undefined';
        });
    }
    return vimeoApiPromise;
}

function loadYouTubeApi() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    if (!youtubeApiPromise) {
        youtubeApiPromise = new Promise(function (resolve, reject) {
            var previousCallback = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = function () {
                if (typeof previousCallback === 'function') previousCallback();
                resolve();
            };
            loadExternalScript('https://www.youtube.com/iframe_api', function () {
                return !!(window.YT && window.YT.Player);
            }).then(function () {
                if (window.YT && window.YT.Player) resolve();
            }).catch(reject);
        });
    }
    return youtubeApiPromise;
}

// Counter
(function (window) {
    'use strict';

    window.animateCounter = function (el, target, duration = 2000) {
        const startTime = performance.now();
        const startValue = 0;

        function update(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const currentValue = Math.floor(startValue + (target - startValue) * progress);
            el.textContent = currentValue.toLocaleString();

            if (progress < 1) {
                requestAnimationFrame(update);
            }
        }

        requestAnimationFrame(update);
    };


}(window));

// HLS Videos


function initHlsPlayers() {
    const hlsVideos = document.querySelectorAll("video[data-hls-src]");

    // Abbrechen, wenn kein HLS-Video vorhanden ist
    if (hlsVideos.length === 0) return;
    hlsVideos.forEach(function (video) {
        // Jeder Video-Player wird einzeln isoliert
        try {
            var hlsSrc = video.getAttribute("data-hls-src");
            if (!hlsSrc) return;

            if (typeof Hls !== "undefined" && Hls.isSupported()) {
                var hls = new Hls({ capLevelToPlayerSize: true });

                // Event-Listener für HLS.js Fehler abfangen
                hls.on(Hls.Events.ERROR, function (event, data) {
                    if (data.fatal) {
                        console.warn("HLS-Fehler bei Video abgefangen:", data, video);
                    }
                });

                hls.loadSource(hlsSrc);
                hls.attachMedia(video);

                // Sobald das HLS-Manifest geladen ist -> Sofort abspielen!
                hls.on(Hls.Events.MANIFEST_PARSED, function () {
                    if (video.closest('.front-header-slider') && !video.closest('.swiper-slide-active')) return;
                    if (video.classList.contains('js-viewport-video')) return;
                    video.play().catch(function (error) {
                        console.log("Autoplay vom Browser blockiert:", error);
                    });
                });

            } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
                // Für Safari (iOS / Mac) mit nativer HLS-Unterstützung
                video.src = hlsSrc;
                video.addEventListener("loadedmetadata", function () {
                    if (video.closest('.front-header-slider') && !video.closest('.swiper-slide-active')) return;
                    if (video.classList.contains('js-viewport-video')) return;
                    video.play().catch(function (error) {
                        console.log("Autoplay vom Browser blockiert:", error);
                    });
                });
            }
        } catch (err) {
            // Falls bei DIESEM Video etwas schiefgeht, fangen wir es ab
            // und die Schleife läuft für alle anderen Videos einfach weiter.
            console.error("Fehler beim Initialisieren eines HLS-Videos:", err, video);
        }
    });
}

initHlsPlayers();
// END HLS Videos

function postMessageToPlayer(player, command) {
    if (player == null || command == null) {
        return;
    }
    player.contentWindow.postMessage(JSON.stringify(command), "*");
}

function playPauseVideo(currentSlide, control) {
    var currentSlide, slideType, startTime, player, video, previewImage;

    if (currentSlide == undefined) {
        return;
    }
    slideType = currentSlide != null && currentSlide.classList != null && currentSlide.classList.length > 0 ? currentSlide.classList[0] : "";
    if (currentSlide.querySelector(".embed-player") == undefined) {
        return;
    }
    player = currentSlide.querySelector(".embed-player");
    previewImage = currentSlide.querySelector(".header-image-video");
    //startTime = currentSlide.data("video-start");
    startTime = currentSlide.dataset.videoStart;
    //var videoid = currentSlide.data("id");
    var videoid = currentSlide.dataset.id;

    if (slideType === "vimeo") {

        switch (control) {
            case "play":

                if (typeof Vimeo !== 'undefined') {

                    setTimeout(function () {
                        //postMessageToPlayer(player,
                        //    {
                        //        "method": "setCurrentTime",
                        //        "value": 0
                        //    });
                        players[videoid].play();
                        setTimeout(function () {
                            if (previewImage != undefined) {
                                if (previewImage.classList.contains("hidevideoimage") == false) {
                                    previewImage.classList.add("hidevideoimage");
                                }
                            }
                        },
                            1000);
                    },
                        2000);
                } else {


                    setTimeout(function () {
                        postMessageToPlayer(player,
                            {
                                "method": "setCurrentTime",
                                "value": startTime
                            });
                        postMessageToPlayer(player,
                            {
                                "method": "play",
                                "value": 1
                            });
                        setTimeout(function () {
                            if (previewImage != undefined) {
                                if (previewImage.classList.contains("hidevideoimage") == false) {
                                    previewImage.classList.add("hidevideoimage");
                                }
                            }
                        },
                            1000);

                    }, 2000);
                }
                break;
            case "pause":
                postMessageToPlayer(player,
                    {
                        "method": "pause",
                        "value": 1
                    });
                break;
        }
    } else if (slideType === "youtube") {

        switch (control) {
            case "play":
                setTimeout(function () {
                    //player.playVideo();
                    //players[videoid].play();
                    postMessageToPlayer(player,
                        { event: 'command', func: 'seekTo', args: [0, true] });

                    postMessageToPlayer(player,
                        {
                            "event": "command",
                            "func": "mute"
                        });
                    postMessageToPlayer(player,
                        {
                            "event": "command",
                            "func": "playVideo"
                        });


                    //var playeryoutube = new YT.Player(player);

                    //// Wenn es mehrere Slide gibt dann Swiper next
                    //playeryoutube.addEventListener("onStateChange",
                    //    function (state) {
                    //        console.log(state);
                    //        if (state.data == YT.PlayerState.ENDED) {
                    //            var previewImage = document.querySelector('.header-image-video.hidevideoimage');
                    //            if (previewImage != undefined && previewImage.classList.contains("hidevideoimage")) {
                    //                previewImage.classList.remove('hidevideoimage');
                    //            }
                    //            //postMessageToPlayer(that,
                    //            //    { event: 'command', func: 'seekTo', args: [0, true] });
                    //            //playPauseVideo(that, "pause");
                    //            //mySwiper.slideNext(); // Springe zum nächsten Slide, wenn das Video fertig ist
                    //            headerslider.slideNext();
                    //            playeryoutube.seekTo(0); // Setze das Video auf 0 Sekunden zurück

                    //        }
                    //    });
                    setTimeout(function () {
                        if (previewImage != undefined) {
                            if (previewImage.classList.contains("hidevideoimage") == false) {
                                previewImage.classList.add("hidevideoimage");
                            }
                        }
                    },
                        1000);
                },
                    2000);
                break;
            case "pause":
                postMessageToPlayer(player,
                    {
                        "event": "command",
                        "func": "pauseVideo"
                    });
                break;
        }
    } else if (slideType === "video") {
        video = currentSlide.querySelector("video");
        if (video != null) {
            if (control === "play") {
                if (previewImage != undefined) {
                    if (previewImage.classList.contains("hidevideoimage") == false) {
                        previewImage.classList.add("hidevideoimage");
                    }
                }
                // Unmute video
                //video.muted = false;

                var playPromise = video.play();
                if (playPromise !== undefined) {

                    playPromise.then(function () {

                    }).catch(function (error) {
                        //video.muted = true;
                        video.play();
                    });
                }


            } else {
                video.pause();
            }
        }
    }
}


function loadRecaptchaIfNeeded(siteKey) {
    consolelog("loadRecaptchaIfNeeded:" + siteKey);
    return new Promise((resolve, reject) => {
        // Wenn bereits geladen → sofort loslegen
        if (window.grecaptcha && window.grecaptcha.execute) {
            window.grecaptcha.ready(() => resolve(window.grecaptcha));
            return;
        }

        // Wenn schon im DOM aber noch nicht verfügbar → warten
        if (document.querySelector(`script[src*="recaptcha/api.js"]`)) {
            const interval = setInterval(() => {
                if (window.grecaptcha && window.grecaptcha.execute) {
                    clearInterval(interval);
                    window.grecaptcha.ready(() => resolve(window.grecaptcha));
                }
            }, 50);
            return;
        }

        // Andernfalls neu laden
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
            if (window.grecaptcha) {
                window.grecaptcha.ready(() => resolve(window.grecaptcha));
            } else {
                reject("reCAPTCHA konnte nicht initialisiert werden.");
            }
        };

        script.onerror = () => reject("Fehler beim Laden von reCAPTCHA.");
        consolelog("Append Recaptcha");
        document.head.appendChild(script);
    });
}

// get a cross-browser function for adding events, place this in [global] or somewhere you can access it
var on = (function () {
    if (window.addEventListener) {
        return function (target, type, listener) { target.addEventListener(type, listener, false); };
    } else {
        return function (object, sEvent, fpNotify) { object.attachEvent("on" + sEvent, fpNotify); };
    }
}());

function containsObject(obj, list) {
    var i;
    if (list == undefined) {
        return false;
    }
    for (i = 0; i < list.length; i++) {
        if (list[i] === obj) {
            return true;
        }
    }

    return false;
}

function getOffset(that) {
    var rect = that.getBoundingClientRect();
    return {
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
    };
}

// Cookies
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

function moveElement(array, fromIndex, toIndex) {
    var element = array.splice(fromIndex, 1)[0];
    arr.splice(toIndex, 0, element);
    return arr;
}


// ==================== BackgroundImage
// ================== Global Functions ecapsulated
(function (window) {
    'use strict';
    window.updateContainerFunc = function () {
        containers = document.querySelectorAll('.bgimage');
        containers.forEach(function (that) {
            if (containsObject(that, containersSum)) {
                return true;
            }

            var respimgval = that.dataset.respImg;
            var nobg = that.dataset.respImgNobg;
            var bgcolor = that.dataset.respImgBgcolor;
            var noinitbg = false;
            var value = that.style.backgroundImage;
            if (respimgval != '' && respimgval != undefined) {
                value = respimgval;
                noinitbg = true;
            }

            if (noinitbg == false && (value == undefined || value.indexOf('url') < 0 || value.indexOf("width") == -1)) {
                return false;
            }

            var url = noinitbg ? value : value.match(urlRegex)[1];
            if (url == undefined) {
                return null;
            }

            var parts = url.split('?');
            var data = {
                file: parts[0],
                parameter: { cc: '', mode: 'crop', width: 0, height: 0, format: 'jpeg', quality: 84 },
                noinitbg: noinitbg
            };
            parts[1].replace(parameterRegex,
                function (m, k, v) {
                    k = k.toLowerCase();
                    data.parameter[k] = (k === 'width' || k === 'height' || k === 'heightratio') ? parseFloat(v) : v;
                });

            data.parameter.mode = data.parameter.mode || 'crop';
            if (data.parameter.height == undefined &&
                data.parameter.width != undefined &&
                data.parameter.heightratio != undefined) {
                data.parameter.height = data.parameter.width * data.parameter.heightratio;
                delete data.parameter.heightratio;
            }

            if (noinitbg && nobg != "true") {
                if (bgcolor != undefined) {
                    that.style.backgroundColor = bgcolor;
                    //that.style.background = 'url(data:image/svg+xml,<svg class="lds-spinner" width="200px" height="200px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="animation-play-state: running; animation-delay: 0s; background: none;"><g transform="rotate(0 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(30 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(60 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(90 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(120 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(150 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(180 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(210 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(240 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(270 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(300 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(330 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g></svg>)';
                    // url('data:image/svg+xml,<svg class="lds-spinner" width="200px" height="200px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="animation-play-state: running; animation-delay: 0s; background: none;"><g transform="rotate(0 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(30 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(60 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(90 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(120 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(150 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(180 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(210 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(240 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(270 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(300 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g><g transform="rotate(330 50 50)" style="animation-play-state: running; animation-delay: 0s;"><rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="%23CE7285" style="animation-play-state: running; animation-delay: 0s;"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate></rect></g></svg>')

                } else {
                    that.style.backgroundColor = '#efefef';

                }
            }
            that.setAttribute('data-background-data', JSON.stringify(data));
            containersSum.push(that);

            //return true;
        });
        //return result;

    }

    window.updateBackgrounds = function (resized) {
        var scrollTop = window.pageYOffset | document.body.scrollTop,
            scrollBottom = scrollTop + window.innerHeight;
        containers.forEach(function (container) {
            var containerWidth = container.clientWidth,
                containerHeight = container.clientHeight;
            if (container.dataset.backgroundData == null || containerWidth == 0) {
                return;
            }
            var data = JSON.parse(container.dataset.backgroundData);

            // Ignore image containers outside viewport.
            var rect = container.getBoundingClientRect();
            var offset = {
                top: rect.top + window.scrollY,
                left: rect.left + window.scrollX,
            };

            var containerTop = offset.top,
                containerBottom = containerTop + containerHeight;
            if (containerTop >= (scrollBottom + threshold) || (containerBottom <= scrollTop - threshold)) {
                return;
            }
            // Get best matching background size.
            var bestWidth = 0,
                bestHeight = 0;

            var containerRatio = containerHeight / containerWidth;
            var rawRatio = data.parameter.height / data.parameter.width;

            var indexTreshold = 0;
            for (var i = 0; i < sizes.length && bestWidth < containerWidth; i++) {
                bestWidth = sizes[i];
                indexTreshold = i;
            }

            //if (indexTreshold < sizes.length - 2) {
            //    bestWidth = sizes[indexTreshold + 2];
            //} else
            if (indexTreshold < sizes.length - 1) {
                bestWidth = sizes[indexTreshold + 1];
            } else {
                bestWidth = sizes[indexTreshold];
            }
            /* }*/


            // Break if current images fits.
            if (container.dataset.backgroundData == undefined) {
                return;
            }


            bestHeight = bestWidth * rawRatio;
            indexTreshold = 0;
            if (container.dataset.respImgAutosize == "true") {
                bestHeight = 0;
                for (var j = 0; j < sizes.length && bestHeight < containerHeight; j++) {
                    bestHeight = sizes[j];
                    indexTreshold = j;
                }

                if (indexTreshold < sizes.length - 1) {
                    bestHeight = sizes[indexTreshold + 1];
                } else {
                    bestHeight = sizes[indexTreshold];
                }
            }


            bestWidth = bgimageScale * bestWidth;
            bestHeight = parseInt(bgimageScale * bestHeight);
            if (data.parameter.width === bestWidth && data.parameter.height === bestHeight) {
                //if (container.dataset.respImgAutosize != "true" && data.noinitbg === true && container.style.backgroundImage == '') {
                //    container.style.backgroundImage = 'url(' + container.dataset.respImg + ')';
                //    container.classList.add('loaded');
                //}
                // Wenn bereits das richtige Image geladen wurde Aufruf abbrechen
                if (container.style.backgroundImage != '') {
                    container.classList.add('loaded');
                    return;
                }
            }

            // Update background parameter.
            data.parameter['width'] = bestWidth;
            data.parameter['height'] = bestHeight;
            data.parameter['quality'] = window.featureResult.hasWebp ? bgimageWebpQuality : bgimageJpegQuality;
            //data.parameter['format'] = window.featureResult.hasWebp ? 'webp' : 'jpeg';
            if (data.file.indexOf('.png') > -1) {
                data.parameter['format'] = "png";
            } else if (data.file.indexOf('.svg') > -1) {
                data.parameter['format'] = "svg";
            } else {
                data.parameter['format'] = window.featureResult.hasWebp ? 'webp' : 'jpeg';
            }
            container.setAttribute('data-background-data', JSON.stringify(data));
            // Build new image URL.
            if (bestWidth == 0 && bestHeight == 0) {
                return;
            }

            var bestImageUrl = data.file + '?';

            for (var k in data.parameter) {
                if (data.parameter[k].length > 0 || data.parameter[k] > 0) {
                    bestImageUrl += k + '=' + data.parameter[k] + '&';
                }
            }
            bestImageUrl = bestImageUrl.substring(0, bestImageUrl.length - 1);
            if (container.dataset.respImgManual == "true") {
                container.dataset.respImgSrc = bestImageUrl;
                return;
            }

            // Preload file and set background image.
            // For Swiper
            if (container.classList.contains('swiper-lazy')) {
                container.setAttribute('data-background', bestImageUrl);
            } else {
                var preloadImage = new Image();
                preloadImage.onload = function () {
                    container.style.backgroundImage = "url('" + this.src + "')";
                    container.classList.add('loaded');
                };
                preloadImage.src = bestImageUrl;
            }
        });
    }

    // =================== Bind Iframe and Image Src 
    window.updateIframeSrc = function (resized) {
        var scrollTop = window.pageYOffset | document.body.scrollTop,
            scrollBottom = scrollTop + window.innerHeight;

        iframecontainer.forEach(function (container) {
            var containerWidth = container.clientWidth,
                containerHeight = container.clientHeight;

            // Ignore containers without image.
            /*if ($container.css("background-image").indexOf('url') < 0)
                return;*/

            // Ignore image containers outside viewport.
            var offset = getOffset(container);
            var containerTop = offset.top,
                containerBottom = containerTop + containerHeight;
            if (containerTop >= (scrollBottom + threshold) || (containerBottom <= scrollTop - threshold)) {
                return;
            }
            if (container.classList.contains("srcset") == false) {
                container.setAttribute("src", container.dataset.src);
                container.classList.add("srcset");
            }
        });
    }

    document.addEventListener('DOMContentLoaded',
        function () {
            // Background
            window.updateContainerFunc();
            window.updateBackgrounds();
            window.addEventListener('resize', window.updateBackgrounds);
            window.addEventListener('scroll', window.updateBackgrounds);
        });

    // Sameheight helper
    //window.sameHeight = function (group, elements) {
    //    var i, j, blocks, items, rows, currentRow;
    //    blocks = document.getElementsByClassName(group);

    //    // Schwellenwert für den vertikalen Abstand zwischen Elementen in derselben Zeile
    //    var threshold = 100;

    //    // Durchlaufe alle Elemente in der Gruppe
    //    for (i = 0; i < blocks.length; i++) {
    //        items = blocks[i].getElementsByClassName(elements);
    //        rows = [];
    //        currentRow = [];

    //        // Teile die Elemente in Zeilen auf
    //        for (j = 0; j < items.length; j++) {
    //            currentRow.push(items[j]);
    //            var nextElement = items[j + 1];

    //            // Überprüfe, ob das nächste Element in derselben Zeile ist
    //            if (!nextElement || Math.abs(nextElement.offsetTop - items[j].offsetTop) > threshold) {
    //                rows.push(currentRow);
    //                currentRow = [];
    //            }
    //        }

    //        // Setze die Höhe der Elemente in jeder Zeile gleich
    //        for (j = 0; j < rows.length; j++) {
    //            var rowItems = rows[j];
    //            var maxHeight = 0;

    //            // Ermittle die maximale Höhe in der Zeile
    //            for (var k = 0; k < rowItems.length; k++) {
    //                rowItems[k].style.height = 'auto';
    //                if (rowItems[k].clientHeight > maxHeight) {
    //                    maxHeight = rowItems[k].clientHeight;
    //                }
    //            }

    //            // Setze die Höhe aller Elemente in der Zeile auf die maximale Höhe
    //            for (var k = 0; k < rowItems.length; k++) {
    //                rowItems[k].style.height = maxHeight + 'px';
    //            }
    //        }
    //    }
    //};
}(window));

// GA Events
(function (window) {
    'use strict';
    window.gaTrackEvent = function (el) {
        if (website.hasTagmanager) {
            var data = el.dataset.gaq.split('|');
            var act = data[0];
            var cat = data[1];
            var lab = data[2];
            window.gaPushEvent(act, cat, lab);
        } else {
            var data = el.dataset.gaq.split('|');
            var cat = data[0];
            var act = data[1];
            var lab = data[2];
            try {
                gtag('event', act, { 'event_category': cat, 'event_label': lab });
            } catch (ex) {
            }
        }
    }

    window.gaPushEvent = function (act, cat, lab) {
        try {
            window.dataLayer.push({
                'event': 'ga-ev',
                'ga-ev-cat': cat,
                'ga-ev-act': act,
                'ga-ev-lab': lab
            });
        } catch (ex) {
        }
    }
}(window));

// GA Events
(function (window) {
    'use strict';

    window.showLoading = function () {
        if (document.body.classList.contains("loading") == false) {
            document.body.classList.add("loading");
        }
    }

    window.hideLoading = function () {
        if (document.body.classList.contains("loading") == true) {
            document.body.classList.remove("loading");
        }
    }

}(window));

Fancybox.bind("[data-fancybox]");



// PETITE VUE

const app = reactive({
    menuActive: false,
    lastDoubleTabToGoElement: null,
    currentNavId: null,
    scrolled: false,
    pageinit: false,
    enquiryChilds: [0, 0, 0, 0, 0, 0, 0],
    enquiryroomscount: 1,

});

//this.app.pageinit = true;

createApp({
    app,
    bindFrontHeaderSlider() {
        var root = document.querySelector('.front-header-slider');
        if (!root) return;

        var slideCount = root.querySelectorAll('.swiper-slide').length;
        var imageDelay = parseInt(root.dataset.imageDelay || '5000', 10);
        var imageTimer = null;
        var slider = null;
        var youtubePlayers = new Map();
        var vimeoPlayers = new Map();
        var frontHeaderResizeFrame = null;

        // YouTube and Vimeo are treated as 16:9 media and scaled like object-fit: cover.
        // Calculate against each slide so portrait, landscape and tablet headers all fill.
        function resizeFrontHeaderPlayers() {
            window.cancelAnimationFrame(frontHeaderResizeFrame);
            frontHeaderResizeFrame = window.requestAnimationFrame(function () {
                root.querySelectorAll('.front-header-slide__iframe, .front-header-slide__player').forEach(function (current) {
                    var slide = current.closest('.front-header-slide');
                    if (!slide) return;

                    var width = slide.clientWidth;
                    var height = slide.clientHeight;
                    if (!width || !height) return;

                    //var ratio = parseFloat(slide.dataset.videoRatio) || 16 / 9;
                    var ratio = parseFloat(slide.dataset.videoRatio) || 4 / 3;
                    var playerWidth;
                    var playerHeight;

                    if (width / height < ratio) {
                        playerHeight = height;
                        playerWidth = Math.ceil(height * ratio);
                    } else {
                        playerWidth = width;
                        playerHeight = Math.ceil(width / ratio);
                    }

                    current.style.width = playerWidth + 'px';
                    current.style.height = playerHeight + 'px';
                    current.style.left = '50%';
                    current.style.top = '50%';
                    current.style.right = 'auto';
                    current.style.bottom = 'auto';
                    current.style.position = 'absolute';
                    current.style.transform = 'translate(-50%, -50%)';
                });
            });
        }

        resizeFrontHeaderPlayers();
        if ('ResizeObserver' in window) {
            var frontHeaderResizeObserver = new ResizeObserver(resizeFrontHeaderPlayers);
            frontHeaderResizeObserver.observe(root);
        } else {
            window.addEventListener('resize', resizeFrontHeaderPlayers);
        }

        function isActive(slide) {
            return slider && slider.slides[slider.activeIndex] === slide;
        }

        function nextSlide() {
            if (slider && slideCount > 1) slider.slideNext();
        }

        function pauseAllVideos() {
            root.querySelectorAll('.front-header-slide').forEach(function (slide) {
                slide.classList.remove('is-playing');
            });
            root.querySelectorAll('video').forEach(function (video) {
                video.pause();
                try { video.currentTime = 0; } catch (error) { }
            });
            youtubePlayers.forEach(function (player) {
                if (player && player.pauseVideo) {
                    player.pauseVideo();
                    player.seekTo(0, true);
                }
            });
            vimeoPlayers.forEach(function (player) {
                player.pause().catch(function () { });
                player.setCurrentTime(0).catch(function () { });
            });
        }

        function activateSlide() {
            window.clearTimeout(imageTimer);
            var slide = slider.slides[slider.activeIndex];
            if (!slide) return;

            var type = slide.dataset.videoType;
            if (!type) {
                if (slideCount > 1) imageTimer = window.setTimeout(nextSlide, imageDelay);
                return;
            }

            if (type === 'html5') {
                var video = slide.querySelector('video');
                if (video) {
                    slide.classList.add('is-playing');
                    video.play().catch(function () { });
                }
            } else if (type === 'youtube') {
                var youtubePlayer = youtubePlayers.get(slide);
                if (youtubePlayer && youtubePlayer.playVideo) {
                    slide.classList.add('is-playing');
                    youtubePlayer.playVideo();
                }
            } else if (type === 'vimeo') {
                var vimeoPlayer = vimeoPlayers.get(slide);
                if (vimeoPlayer) {
                    slide.classList.add('is-playing');
                    vimeoPlayer.play().catch(function () { });
                }
            }
        }

        root.querySelectorAll('.front-header-slide--video video').forEach(function (video) {
            var slide = video.closest('.swiper-slide');
            video.addEventListener('ended', function () {
                if (isActive(slide)) nextSlide();
            });
        });

        var youtubeSlides = root.querySelectorAll('[data-youtube-id]');
        if (youtubeSlides.length) {
            loadYouTubeApi().then(function () {
                youtubeSlides.forEach(function (element) {
                    var slide = element.closest('.swiper-slide');
                    var player = new window.YT.Player(element, {
                        videoId: element.dataset.youtubeId,
                        playerVars: { autoplay: 0, controls: 0, disablekb: 1, fs: 0, loop: 0, modestbranding: 1, mute: 1, playsinline: 1, rel: 0 },
                        events: {
                            onReady: function (event) {
                                event.target.mute();
                                youtubePlayers.set(slide, event.target);
                                if (isActive(slide)) {
                                    slide.classList.add('is-playing');
                                    event.target.playVideo();
                                }
                            },
                            onStateChange: function (event) {
                                if (event.data === window.YT.PlayerState.ENDED && isActive(slide)) nextSlide();
                            }
                        }
                    });
                    youtubePlayers.set(slide, player);
                });
            }).catch(function (error) { console.error('YouTube Header konnte nicht initialisiert werden.', error); });
        }

        var vimeoFrames = root.querySelectorAll('.front-header-slide__iframe');
        if (vimeoFrames.length) {
            loadVimeoApi().then(function () {
                vimeoFrames.forEach(function (iframe) {
                    var slide = iframe.closest('.swiper-slide');
                    var player = new window.Vimeo.Player(iframe);
                    vimeoPlayers.set(slide, player);
                    player.setVolume(0);
                    player.on('ended', function () {
                        if (isActive(slide)) nextSlide();
                    });
                    if (isActive(slide)) {
                        slide.classList.add('is-playing');
                        player.play().catch(function () { });
                    }
                });
            }).catch(function (error) { console.error('Vimeo Header konnte nicht initialisiert werden.', error); });
        }

        slider = new Swiper(root, {
            speed: 900,
            slidesPerView: 1,
            rewind: slideCount > 1,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            allowTouchMove: slideCount > 1,
            modules: [Navigation, EffectFade],
            navigation: {
                nextEl: root.querySelector('.swiper-button-next'),
                prevEl: root.querySelector('.swiper-button-prev')
            },
            on: {
                init: function (instance) {
                    slider = instance;
                    window.updateContainerFunc();
                    window.updateBackgrounds();
                    activateSlide();
                },
                slideChangeTransitionStart: function () {
                    window.clearTimeout(imageTimer);
                    pauseAllVideos();
                },
                slideChangeTransitionEnd: activateSlide
            }
        });
    },
    // ================== Swiper
    bindswiper() {
        // https://swiperjs.com/swiper-api

        this.bindFrontHeaderSlider();


        // Vimeo
        document.querySelectorAll('.headerslider:not(.front-header-slider) .vimeo .embed-player').forEach(function (that) {
            if (typeof Vimeo !== 'undefined') {
                var playervimeo = new Vimeo.Player(that);
                //playervimeo.api('setVolume', 0);

                playervimeo.on('play',
                    function () {


                        playervimeo.setCurrentTime(0);

                        //headerslider.autoplay.stop();
                    });

                playervimeo.on('ended',
                    function () {
                        var previewImage = document.querySelector('.header-image-video.hidevideoimage');
                        if (previewImage != undefined && previewImage.classList.contains("hidevideoimage")) {
                            previewImage.classList.remove('hidevideoimage');
                        }
                        playervimeo.setCurrentTime(0);
                        //playervimeo.play();

                        //headerslider.autoplay.start();
                        headerslider.slideNext();
                    });

                players.push(playervimeo);
            }
        });

        document.querySelectorAll('.headerslider:not(.front-header-slider) .video .embed-player').forEach(function (that) {
            that.addEventListener('ended', myHandler, false);
            function myHandler(e) {
                var previewImage = document.querySelector('.header-image-video.hidevideoimage');
                if (previewImage != undefined && previewImage.classList.contains("hidevideoimage")) {
                    previewImage.classList.remove('hidevideoimage');
                }

                headerslider.slideNext();

                // What you want to do after the event
            }
        });


        var iframes = document.querySelectorAll('.headerslider:not(.front-header-slider) .embed-player');

        //lazyImages = $slideWrapper.find('.slide-image'),
        //lazyCounter = 0;
        // Resize player
        function resizePlayer(iframes, ratio) {
            if (!iframes[0]) {
                return;
            }
            var win = document.querySelectorAll('.headerslider:not(.front-header-slider)')[0],
                width = win.clientWidth,
                playerWidth,
                height = win.clientHeight,
                playerHeight,
                ratio = ratio || 16 / 9;


            iframes.forEach(function (that) {
                var current = that;
                if (width / ratio < height) {
                    playerWidth = Math.ceil(height * ratio);
                    current.style.width = playerWidth + "px";
                    current.style.height = height + "px";
                    current.style.left = "50%";
                    current.style.top = height;
                    current.style.position = "relative";
                    current.style.transform = "translateX(-50%)";
                } else {
                    playerHeight = Math.ceil(width / ratio);
                    current.style.width = width + "px";
                    current.style.height = playerHeight + "px";
                    current.style.left = 0;
                    current.style.top = (height - playerHeight) / 2 + "px";
                }
            });
        }


        // When the slide is changing


        if (document.querySelectorAll('.headerslider:not(.front-header-slider) .swiper-slide').length > 0) {

            headerslider = new Swiper('.headerslider:not(.front-header-slider)',
                {
                    speed: 1000,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    infinite: true,
                    loop: true,
                    autoplay: {
                        delay: 4000
                    },
                    modules: [Navigation, Pagination, Autoplay, EffectFade, Keyboard, Mousewheel, Scrollbar],

                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    allowTouchMove: false,
                    //centeredSlides: true,
                    navigation: {
                        nextEl: '.headerslider .swiper-button-next',
                        prevEl: '.headerslider .swiper-button-prev',
                    },
                    pagination: {
                        el: ".headerslider .swiper-pagination",
                        clickable: true,
                        //renderBullet: function(index, className) { return '<span class="' + className + '">0' + (index + 1) + "</span>"; }
                    },
                    preloadImages: false,
                    // Enable lazy loading
                    lazy: {
                        loadPrevNext: true,
                        loadPrevNextAmount: 0
                    },
                    on: {
                        beforeSlideChangeStart: function (el) {

                            playPauseVideo(el.el, "pause");
                        },
                        activeIndexChange: function (el) {
                            var currentSlide = el.el.querySelectorAll(".swiper-slide")[el.activeIndex];
                            if (currentSlide == undefined) {
                                return true;
                            }
                            var slideType = currentSlide != null && currentSlide.classList != null && currentSlide.classList.length > 0 ? currentSlide.classList[0] : null;
                            if (slideType == "vimeo" || slideType == "youtube" || slideType == "video") {
                                //playPauseVideo(el.el, "start");
                                if (headerslider != null) {
                                    setTimeout(function () {
                                        if (headerslider != null) {
                                            headerslider.autoplay.stop();

                                        }
                                    }, 100);
                                }
                                playPauseVideo(currentSlide, "play");
                            } else {

                                setTimeout(function () {
                                    if (headerslider != null && headerslider.autoplay != null) {
                                        headerslider.autoplay.start();
                                    }
                                }, 100);

                                //var autoplaySpeed = currentSlide.attr("data-delay") * 1000;

                            }

                            //setTimeout(function () {
                            //slick = $(slick.$slider);

                        },
                        afterInit: function (el) {
                            setTimeout(function () {
                                var currentSlide = el.el.querySelector(".swiper-slide-visible");
                                var slideType = currentSlide != null && currentSlide.classList != null && currentSlide.classList.length > 0 ? currentSlide.classList[0] : null;
                                if (slideType === "vimeo" || slideType === "youtube" || slideType === "video") {
                                    //playPauseVideo(el.el, "start");
                                    headerslider.autoplay.stop();

                                    playPauseVideo(currentSlide, "play");

                                }
                            },
                                500);
                            iframes = document.querySelectorAll('.headerslider:not(.front-header-slider) .embed-player');
                            resizePlayer(iframes, 16 / 9);
                            window.updateContainerFunc();
                            window.updateBackgrounds();
                        }
                        //$('.swiper-slide').each(function () {
                        //    var youtubePlayer = $(this).find('iframe').get(0);
                        //    if (youtubePlayer) {
                        //        youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                        //    }
                        //});
                    }
                    //spaceBetween: 100,
                });

        }





        if (document.querySelectorAll('.js-offerslider').length > 0) {
            var offersliders = document.querySelectorAll('.js-offerslider');
            offersliders.forEach(function (that) {
                if (that.querySelectorAll('.swiper-slide').length > 1) {
                    var offer = new Swiper(that,
                        {
                            speed: 750,
                            slidesPerView: 1.15,
                            spaceBetween: 14,
                            grabCursor: true,
                            watchOverflow: true,
                            modules: [Scrollbar, Keyboard],
                            keyboard: {
                                enabled: true,
                                onlyInViewport: true
                            },
                            scrollbar: {
                                el: that.querySelector('.swiper-scrollbar'),
                                draggable: true,
                                dragSize: 'auto'
                            },
                            breakpoints: {
                                576: {
                                    slidesPerView: 1.55,
                                    spaceBetween: 15
                                },
                                768: {
                                    slidesPerView: 2.15,
                                    spaceBetween: 24
                                },
                                1024: {
                                    slidesPerView: 3.15,
                                    spaceBetween: 30
                                }
                            },
                            on: {
                                init: function () {
                                    window.updateContainerFunc();
                                    window.updateBackgrounds();
                                }
                            }
                            //spaceBetween: 100,
                        });
                }
            });

        }

        if (document.querySelectorAll('.js-assessment-slider').length > 0) {
            var offersliders = document.querySelectorAll('.js-assessment-slider');
            offersliders.forEach(function (that) {
                if (that.querySelectorAll('.swiper-slide').length > 1) {
                    var offer = new Swiper(that,
                        {
                            speed: 400,
                            slidesPerView: 1.1,
                            spaceBetween: 15,
                            infinite: true,
                            loop: true,
                            // autoHeight: true,
                            autoplay: {
                                delay: 4000
                            },
                            // effect: 'fade',
                            // fadeEffect: {
                            //     crossFade: true
                            // },
                            modules: [Navigation, Pagination, Autoplay],

                            // centeredSlides: true,
                            navigation: {
                                nextEl: that.closest('.assessments-block').querySelector('.assessments-block__next'),
                                prevEl: that.closest('.assessments-block').querySelector('.assessments-block__prev'),
                            },
                            //navigation: {
                            //    nextEl: that.nextElementSibling.querySelector('.swiper-button-next'),
                            //    prevEl: that.nextElementSibling.querySelector('.swiper-button-prev'),
                            //},
                            // pagination: {
                            //     //el: ".headerslider .swiper-pagination",
                            //     el: that.querySelector('.swiper-pagination'),
                            //     clickable: true,
                            //     //renderBullet: function (index, className) { return '<span class="' + className + '">0' + (index + 1) + "</span>"; }
                            // },
                            // //preloadImages: true,
                            //// Enable lazy loading
                            //lazy: {
                            //    loadPrevNext: true,
                            //    loadPrevNextAmount: 1,
                            //    checkInView: true
                            //},

                            breakpoints: {
                                // when window width is >= 320px
                                //320: {
                                //  slidesPerView: 2,
                                //  spaceBetween: 20
                                //},
                                // when window width is >= 480px
                                // 780: {
                                //     slidesPerView: 2,
                                //     spaceBetween: 15,
                                //     slidesPerGroup: 3
                                // },
                                // when window width is >= 640px
                                992: {
                                    slidesPerView: 1,
                                    spaceBetween: 30,
                                    slidesPerGroup: 1
                                }
                            },
                            on: {
                                init: function () {
                                    window.updateContainerFunc();
                                    window.updateBackgrounds();
                                }
                            }
                            //spaceBetween: 100,
                        });
                }
            });

        }

    },

    bindCounters() {
        const animatedCounters = new WeakSet(); // Nutzt WeakSet für automatische Speicherfreigabe

        // 1. IntersectionObserver für das Triggern beim Reinscrollen
        const counterObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const el = entry.target;

                    // Prüfen, ob der Counter bereits gelaufen ist
                    if (animatedCounters.has(el)) return;

                    const target = parseInt(el.dataset.target, 10);
                    if (!isNaN(target) && typeof window.animateCounter === 'function') {
                        window.animateCounter(el, target);
                        animatedCounters.add(el);
                    }

                    // Sobald er 1x gezählt wurde, Beobachtung für dieses Element aufheben
                    observer.unobserve(el);
                }
            });
        }, {
            threshold: 0.2 // Startet, wenn 20% des Elements sichtbar sind
        });

        // 2. Alle Counter-Elemente beim Observer registrieren
        document.querySelectorAll('.js-counter').forEach(el => {
            counterObserver.observe(el);
        });
    },
    bindViewportVideos() {
        const videos = document.querySelectorAll('.js-viewport-video');
        if (videos.length === 0) return;

        const youtubePlayers = new WeakMap();
        const vimeoPlayers = new WeakMap();
        const shouldPlay = new WeakMap();
        const playTimers = new WeakMap();

        const startVideo = video => {
            if (video.dataset.videoProvider === 'youtube') {
                const player = youtubePlayers.get(video);
                if (player) {
                    player.mute();
                    player.playVideo();
                }
                return;
            }

            if (video.dataset.videoProvider === 'vimeo') {
                const player = vimeoPlayers.get(video);
                if (player) {
                    player.setMuted(true).then(() => player.play()).catch(() => {});
                }
                return;
            }

            // Muted is required for autoplay in all modern browsers.
            video.muted = true;
            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.catch(() => {
                    // The browser may still reject autoplay because of a local policy.
                });
            }
        };

        const playVideo = video => {
            shouldPlay.set(video, true);
            if (playTimers.has(video)) return;

            const timer = window.setTimeout(() => {
                playTimers.delete(video);
                if (shouldPlay.get(video)) startVideo(video);
            }, 800);
            playTimers.set(video, timer);
        };

        const pauseVideo = video => {
            shouldPlay.set(video, false);
            if (playTimers.has(video)) {
                window.clearTimeout(playTimers.get(video));
                playTimers.delete(video);
            }

            if (video.dataset.videoProvider === 'youtube') {
                const player = youtubePlayers.get(video);
                if (player) player.pauseVideo();
                return;
            }

            if (video.dataset.videoProvider === 'vimeo') {
                const player = vimeoPlayers.get(video);
                if (player) player.pause().catch(() => {});
                return;
            }

            video.pause();
        };

        const youtubeVideos = Array.from(videos).filter(video => video.dataset.videoProvider === 'youtube');
        if (youtubeVideos.length > 0) {
            loadYouTubeApi().then(() => {
                youtubeVideos.forEach(video => {
                    const player = new window.YT.Player(video, {
                        events: {
                            onReady: event => {
                                youtubePlayers.set(video, event.target);
                                event.target.mute();
                                if (shouldPlay.get(video) && !playTimers.has(video)) {
                                    event.target.playVideo();
                                }
                            },
                            onStateChange: event => {
                                if (event.data === window.YT.PlayerState.PLAYING) {
                                    video.closest('.video-block__media')?.classList.add('is-playing');
                                }
                            }
                        }
                    });
                    youtubePlayers.set(video, player);
                });
            }).catch(() => {
                // Keep the preview frame visible if the YouTube API cannot load.
            });
        }

        const vimeoVideos = Array.from(videos).filter(video => video.dataset.videoProvider === 'vimeo');
        if (vimeoVideos.length > 0) {
            loadVimeoApi().then(() => {
                vimeoVideos.forEach(video => {
                    const player = new window.Vimeo.Player(video);
                    vimeoPlayers.set(video, player);
                    player.setMuted(true).catch(() => {});
                    player.on('play', () => {
                        video.closest('.video-block__media')?.classList.add('is-playing');
                    });
                    player.ready().then(() => {
                        if (shouldPlay.get(video) && !playTimers.has(video)) {
                            player.play().catch(() => {});
                        }
                    }).catch(() => {});
                });
            }).catch(() => {
                // Keep the preview frame visible if the Vimeo API cannot load.
            });
        }

        videos.forEach(video => {
            if (!video.dataset.videoProvider) {
                video.addEventListener('playing', () => {
                    video.closest('.video-block__media')?.classList.add('is-playing');
                }, { once: true });
            }
        });

        const videoObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const video = entry.target;
                if (entry.isIntersecting && !document.hidden) {
                    playVideo(video);
                } else {
                    pauseVideo(video);
                }
            });
        }, {
            threshold: 0.35
        });

        videos.forEach(video => videoObserver.observe(video));

        document.addEventListener('visibilitychange', () => {
            videos.forEach(video => {
                if (document.hidden) {
                    pauseVideo(video);
                } else {
                    const bounds = video.getBoundingClientRect();
                    const visibleHeight = Math.min(bounds.bottom, window.innerHeight) - Math.max(bounds.top, 0);
                    if (visibleHeight >= bounds.height * 0.35) playVideo(video);
                }
            });
        });
    },
    bindPortfolioFilter() {
        const filter = document.querySelector('.portfolio-filter');
        const cards = Array.from(document.querySelectorAll('[data-estate-card]'));
        if (!cards.length) return;

        const empty = document.querySelector('.portfolio-list__empty');
        const loadMore = document.querySelector('[data-portfolio-load-more]');
        const pageSize = 12;
        let visibleCount = pageSize;
        let matchingCards = cards;
        const normalizeCategory = value => String(value || '')
            .trim()
            .toLocaleLowerCase()
            .replace(/[\s_-]+/g, '');
        const categoryAliases = {
            penthouse: 'penthouse',
            villa: 'villa',
            new: 'new',
            newproject: 'new',
            newprojects: 'new'
        };
        const requestedCategories = new URLSearchParams(window.location.search)
            .getAll('cat')
            .flatMap(value => String(value).split(','))
            .map(normalizeCategory)
            .map(value => categoryAliases[value])
            .filter(Boolean);
        const selectedEstateTypes = new Set(requestedCategories);

        const renderCards = () => {
            cards.forEach(card => {
                card.hidden = true;
            });
            matchingCards.slice(0, visibleCount).forEach(card => {
                card.hidden = false;
            });

            if (empty) empty.hidden = matchingCards.length !== 0;
            if (loadMore) loadMore.hidden = visibleCount >= matchingCards.length;
            window.updateBackgrounds();
            this.sameheight();
        };

        if (loadMore) {
            loadMore.addEventListener('click', () => {
                visibleCount += pageSize;
                renderCards();
            });
        }

        if (!filter) {
            renderCards();
            return;
        }

        const toggle = filter.querySelector('.portfolio-filter__toggle');
        const panel = filter.querySelector('.portfolio-filter__panel');
        const close = filter.querySelector('.portfolio-filter__close');
        const estateTypeButtons = Array.from(filter.querySelectorAll('[data-estate-type-filter]'));

        const updateEstateTypeButtons = () => {
            estateTypeButtons.forEach(item => {
                const value = String(item.dataset.estateTypeFilter || '').toLocaleLowerCase();
                const active = selectedEstateTypes.has(value);
                item.classList.toggle('is-active', active);
                item.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
        };

        const updateCategoryUrl = () => {
            const url = new URL(window.location.href);
            const categories = estateTypeButtons
                .map(item => String(item.dataset.estateTypeFilter || '').toLocaleLowerCase())
                .filter(value => selectedEstateTypes.has(value))
                .map(value => value === 'new' ? 'newprojects' : value);
            if (categories.length) {
                url.searchParams.set('cat', categories.join(','));
            } else {
                url.searchParams.delete('cat');
            }
            window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        };

        const setOpen = (open) => {
            panel.hidden = !open;
            filter.classList.toggle('is-open', open);
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        };

        toggle.addEventListener('click', () => setOpen(panel.hidden));
        close.addEventListener('click', () => setOpen(false));
        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && !panel.hidden) setOpen(false);
        });

        const applyFilters = () => {
            const values = new FormData(panel);
            const location = String(values.get('location') || '').toLocaleLowerCase();
            const areaFrom = Number(values.get('areaFrom')) || 0;
            const areaTo = Number(values.get('areaTo')) || Number.POSITIVE_INFINITY;

            matchingCards = cards.filter(card => {
                const cardLocation = (card.dataset.location || '').toLocaleLowerCase();
                const cardType = (card.dataset.estateType || '').toLocaleLowerCase();
                const cardArea = Number(card.dataset.area) || 0;
                const matchesEstateType = selectedEstateTypes.size === 0
                    || Array.from(selectedEstateTypes).some(value =>
                        value === 'new' ? card.dataset.isNew === 'true' : cardType === value);
                return (!location || cardLocation === location)
                    && matchesEstateType
                    && cardArea >= areaFrom
                    && cardArea <= areaTo;
            });

            visibleCount = pageSize;
            renderCards();
        };

        panel.addEventListener('submit', event => {
            event.preventDefault();
            applyFilters();
            setOpen(false);
        });

        estateTypeButtons.forEach(button => {
            button.addEventListener('click', () => {
                const value = String(button.dataset.estateTypeFilter || '').toLocaleLowerCase();
                if (selectedEstateTypes.has(value)) {
                    selectedEstateTypes.delete(value);
                } else {
                    selectedEstateTypes.add(value);
                }
                updateEstateTypeButtons();
                updateCategoryUrl();
                applyFilters();
            });
        });

        updateEstateTypeButtons();
        applyFilters();
    },
    // ==================== Data Click
    binddataclick() {
        // If no data-click element exists throws an error
        try {
            var el = document.querySelectorAll('[data-click]');
            el.forEach(function (that) {
                on(that,
                    "click",
                    function () {
                        var destinationURL = this.dataset.click;
                        var target = this.target;
                        if (target == null && this.dataset.target != null) {
                            target = this.dataset.target;
                        }
                        if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
                            var referLink = document.createElement('a');
                            referLink.href = destinationURL;
                            referLink.target = target;
                            document.body.appendChild(referLink);
                            referLink.click();
                        } else if (target == "_blank") {
                            window.open(destinationURL);
                        } else {
                            location.href = destinationURL;
                        }
                    });
            });

        } catch (ex) {

        }
    },
    // ==================== DATA GAQ
    bindgaq() {
        // If no data-click element exists throws an error
        try {
            var el = document.querySelectorAll('[data-gaq]');
            el.forEach(function (that) { on(that, "click", function () { window.gaTrackEvent(this); }); });

        } catch (ex) {

        }
    },
    // ================ Bind SRC 
    bindSrc() {
        iframecontainer = document.querySelectorAll('iframe[data-src]:not(.ignore), img[data-src]');

        window.updateIframeSrc();
        window.addEventListener('resize', window.updateIframeSrc);
        window.addEventListener('scroll', window.updateIframeSrc);
    },
    // ================= Locomotive
    scaleup(currentElements) {
        currentElements = currentElements.filter(x => x.el.classList.contains("scaleup"));
        if (currentElements.length == 0) {
            return;
        }

        currentElements.forEach(function (that) {
            var el = that.el;
            el.childNodes[0].style.transform = "scale(" + (1 + that.progress) + ")";
        });
    },
    scaledown(currentElements) {
        currentElements = currentElements.filter(x => x.el.classList.contains("scaledown"));
        if (currentElements.length == 0) {
            return;
        }

        currentElements.forEach(function (that) {
            var el = that.el;
            el.childNodes[0].style.transform = "scale(" + (1 - (that.progress / 4)) + ")";
        });
    },
    initAos() {
        AOS.init({
            once: true,
            duration: 1500,
            //disable: 'phone'
        });
    },
    bindstoerer() {
        var stoerer = document.getElementById('stoererbox');

        if (stoerer == null || stoerer.length == 0) {
            return;
        }

        var cookieExpires = 1;

        var delay = stoerer.dataset.delay;
        var hidemobile = stoerer.dataset.hidemobile;
        if (Cookies.get('stoerer') != 'shown' && (hidemobile == "false" || (hidemobile == "true" && document.body.clientWidth > 1200))) {
            setTimeout(function (event) {
                Fancybox.show([{
                    src: '#stoererbox',
                    type: "inline"
                }],
                    {
                        on: {
                            done: (fancybox, slide) => {

                                var images = document.querySelectorAll('#stoererbox img[data-src]');
                                images.forEach(function (container) {
                                    container.setAttribute("src", container.dataset.src);

                                });
                                Cookies.set('stoerer',
                                    'shown',
                                    {
                                        expires: cookieExpires,
                                        path: '/'
                                    });
                            }
                        }
                    }
                );
            },
                delay * 1000);
        }
    },
    // MenuScroll
    bindMenuScroll() {
        window.addEventListener('scroll',
            function () {
                if (window.scrollY > 0) {
                    if (document.body.classList.contains("minnav") == false) {
                        document.body.classList.add("minnav");
                    }
                } else {
                    if (document.body.classList.contains("minnav") && document.body.classList.contains("noheader") == false) {
                        document.body.classList.remove("minnav");
                    }
                }
            });
    },
    bindEstateGallery() {
        document.querySelectorAll('.js-estate-scroll-down, .js-header-scroll-down').forEach(function (link) {
            link.addEventListener('click', function (event) {
                const target = document.querySelector(link.getAttribute('href'));
                if (!target) return;

                event.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        });

        document.querySelectorAll('.js-estate-gallery-slider').forEach(function (gallery) {
            const slideCount = gallery.querySelectorAll('.swiper-slide').length;
            if (slideCount < 2) return;

            new Swiper(gallery, {
                modules: [Scrollbar, Keyboard],
                speed: 750,
                slidesPerView: 'auto',
                spaceBetween: 14,
                grabCursor: true,
                watchOverflow: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                scrollbar: {
                    el: gallery.querySelector('.swiper-scrollbar'),
                    draggable: true,
                    dragSize: 'auto'
                },
                breakpoints: {
                    768: {
                        spaceBetween: 24
                    },
                    1200: {
                        spaceBetween: 30
                    }
                }
            });
        });
    },
    // SmoothScroll
    scrollOnLoad() {
        var hash = window.location.hash.substr(1);
        
        if (hash != "") {
            var hashSplitted = hash.split("|");

            for (var i = 0; i < hashSplitted.length; i++) {
                
                if (document.getElementById(hashSplitted[i]) != null) {
                    if (i > 0) {
                        var postop = document.getElementById(hashSplitted[i]).getBoundingClientRect().top + window.scrollY - 100;
                        window.scrollTo({ top: postop, behavior: "smooth" });
                    } else {

                        var postop = document.getElementById(hashSplitted[i]).getBoundingClientRect().top + window.scrollY - 100;
                        window.scrollTo({ top: postop, behavior: "smooth" });
                    }
                }
            }
        }
    },
    scrolldown() {
        this.app.locscroll.scrollTo(document.querySelector('#maincontent'));
    },
    // BindAccordions
    bindaccordions() {
        var acc = document.getElementsByClassName("js-accordion-title");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
        /*Markup:
            <div class="accordion">
                <div class="accordion-title js-accordion-title">@faq.Question</div>
                <div class="accordion-text"><div class="inner">@faq.Answer</div></div>
            </div>             
         */
    },
    // SameHeight
    sameheight() {
        document.body.matchHeight({ elements: '.same-height' });

        const containers = document.querySelectorAll(".same-height-group");
        containers.forEach((container) => {
            container.matchHeight({ elements: '.same-height' });
        });
    },
    bindContentLoadMore() {
        var elements = document.querySelectorAll('.content-text-more');
        elements.forEach(function (element) {

            var computedStyle = window.getComputedStyle(element);
            // Get Actual LineHeight
            var lineHeight = parseInt(computedStyle.getPropertyValue('line-height'));
            var contentTextTrigger = element.querySelector('.content-more .link');
            if (contentTextTrigger != null) {
                // Set Lineheight for more button
                contentTextTrigger.style.lineHeight = (lineHeight * 2) + "px";
            }

            var trigger = element.dataset.trigger;
            if (trigger === undefined) {
                trigger = 200;
            } else {
                trigger = parseInt(element.dataset.trigger);
            }

            var lines = element.dataset.lines;

            if (lines !== undefined) {
                trigger = parseInt(lines) * lineHeight;
            }
            
            if (element.clientHeight < trigger) {
                element.classList.add('visible');
            } else {
                element.style.maxHeight = (trigger + (lineHeight * 2)) + 'px';
                element.style.overflow = 'hidden';
                var moreButton = element.querySelector('.js-content-more');
                moreButton.addEventListener('click', function () {
                    element.classList.add('visible');
                    element.style.maxHeight = '10000px';
                    this.app.sameheight();
                });
            }
        });
        window.dispatchEvent(new Event('resize'));
    },
    bindreadmore() {
        // https://github.com/stephenscaff/read-smore
        //var ReadSmore = window.readSmore;

        // target all read more elements
        var readMoreEls = document.querySelectorAll('.readmore');

        var options = {
            blockClassName: 'read-more',
            moreText: '<span class=" mt-2 d-block readmore-link">' + website.translations.readmore + '</span>',
            lessText: '<span class=" mt-2 d-block readmore-link">' + website.translations.readless + '</span>',
        }
        
        ReadSmore(readMoreEls, options).init();

        document.querySelectorAll('.readmore[data-read-smore-once]').forEach(element => {
            const linkWrap = element.nextElementSibling;
            const link = linkWrap?.querySelector('.read-more__link');
            if (!link) return;

            link.addEventListener('click', () => {
                if (element.classList.contains('is-expanded')) linkWrap.remove();
            }, { once: true });
        });
    },
    //bindDatepicker() {
    //    var $flatpickr = flatpickr("#enquiryform-arrival",
    //        {
    //            locale: website.language,
    //            dateFormat: 'd-m-Y',
    //            minDate: 'today',
    //            allowInput: false,
    //            mode: 'range',
    //            "plugins": [new rangePlugin({ input: "#enquiryform-departure", allowInput: false })]
    //        });
    //},
    //bindForm() {
    
    //    if (document.getElementById('enquiryform') != null) {
    //        //https://just-validate.dev/

    //        const validation = new JustValidate('#enquiryform');

    //        document.querySelectorAll("#enquiryform .required").forEach((el) => {
    //            const rules = [
    //                //{ rule: "required", errorMessage: `${el.dataset.label || "Feld"} ist erforderlich` }
    //                { rule: "required", errorMessage: errormessages.required }
    //            ];

    //            if (el.classList.contains("email")) {
    //                rules.push({ rule: "email", errorMessage: errormessages.email });
    //            }

    //            validation.addField(el, rules);
    //        });


    //        validation.onSuccess((event) => {
    //                window.showLoading();
    //                if (currentEnquiryRequest == true) {
    //                    return true;
    //                }
    //                currentEnquiryRequest = true;
    //                var formData = new FormData(document.getElementById("enquiryform"));
    //                const data = {};

    //                formData.forEach((value, fullKey) => {
    //                    const keys = [];
    //                    const keyPattern = /[^\[\]]+/g;
    //                    let match;
    //                    while ((match = keyPattern.exec(fullKey)) !== null) {
    //                        keys.push(match[0]);
    //                    }

    //                    let current = data;
    //                    for (let i = 0; i < keys.length; i++) {
    //                        const key = keys[i];
    //                        const nextKey = keys[i + 1];

    //                        const isLast = i === keys.length - 1;

    //                        if (isLast) {
    //                            // Wenn key existiert
    //                            if (key in current) {
    //                                // Wenn schon Array → push
    //                                if (Array.isArray(current[key])) {
    //                                    current[key].push(value);
    //                                }
    //                                // Wenn einmaliger Wert vorhanden → in Array umwandeln
    //                                else {
    //                                    current[key] = [current[key], value];
    //                                }
    //                            } else {
    //                                // Direkt als Wert setzen
    //                                current[key] = value;
    //                            }
    //                        } else {
    //                            // Objekt oder Array vorbereiten
    //                            if (!current[key]) {
    //                                current[key] = /^\d+$/.test(nextKey) ? [] : {};
    //                            }
    //                            current = current[key];
    //                        }
    //                    }
    //                });

    //                // childrenages als Array sicherstellen
    //                if (Array.isArray(data.rooms)) {
    //                    data.rooms.forEach(room => {
    //                        if (!Array.isArray(room.childrenages)) {
    //                            if (room.childrenages !== undefined) {
    //                                room.childrenages = [room.childrenages];
    //                            } else {
    //                                room.childrenages = [];
    //                            }
    //                        }
    //                    });
    //                }

    //                // Speichere die Formulardaten (falls erforderlich für Tag Manager)
    //                website.formData = data;



    //                var sendRequest = (payload) => {
    //                    axios.post('/api/json/sendenquiry',
    //                        JSON.stringify(payload),
    //                        {
    //                            headers: {
    //                                'Content-Type': 'application/json'
    //                            }
    //                        }
    //                    ).then((res) => {
    //                        if (res.data == "True") {
    //                            if (website.hasTagmanager) {
    //                                window.gaPushEvent("form", 'enquiry', 'sent');
    //                            }

    //                            document.getElementById("enquiryform").classList.add("d-none");
    //                            document.getElementById("enquiryform-success").classList.remove("d-none");
    //                            document.getElementById("enquiryform-error").classList.add("d-none");
    //                        } else {
    //                            document.getElementById("enquiryform-error").classList.remove("d-none");
    //                        }
    //                    }).catch((error) => {

    //                        if (document.getElementById("enquiryform-success").classList.contains("d-none") == false) {
    //                            document.getElementById("enquiryform-success").classList.add("d-none");
    //                        }
    //                        if (document.getElementById("enquiryform-error").classList.contains("d-none")) {
    //                            document.getElementById("enquiryform-error").classList.remove("d-none");
    //                        }
    //                    }).finally(() => {
    //                        window.hideLoading();
    //                        currentEnquiryRequest = false;
    //                    });
    //                };

    //                // Wenn reCAPTCHA aktiv → Token holen
    //                if (website.googlerecaptcha_active === true) {
    //                    loadRecaptchaIfNeeded(website.googlerecaptcha_pkey)
    //                        .then(grecaptcha => grecaptcha.execute(website.googlerecaptcha_pkey, { action: 'submit' }))
    //                        .then(token => {
    //                            data["grecaptcharesponse"] = token;
    //                            sendRequest(data);
    //                        })
    //                        .catch(error => {
    //                            consolelog("reCAPTCHA Fehler:" + error);
    //                            document.getElementById("enquiryform-error").classList.remove("d-none");
    //                            window.hideLoading();
    //                            currentEnquiryRequest = false;
    //                        });
    //                } else {
    //                    // Ohne reCAPTCHA
    //                    sendRequest(data);
    //                }

    //                return false;


    //                // ggf. AJAX absenden
    //            });;

    //        //https://github.com/welisonmenezes/vanilla-validator 
    //        //var validator = new VanillaValidator({
    //        //    container: '#enquiryform',
    //        //    validationBy: 'onclick',
    //        //    messages: errormessages,
    //        //    novalidateHTML5: false,
    //        //    validateOnFieldChanges: true,
    //        //    callbacks: {
    //        //        error: function (element) {
    //        //            var postop = document.getElementById('enquiryform').querySelector('.msg-error').getBoundingClientRect().top + window.scrollY - 200;
    //        //            window.scrollTo({ top: postop, behavior: "smooth" });
    //        //            //console.log('eachFieldError', element.querySelector('.msg-error'));
    //        //        }
    //        //    },
    //        //    onFormSubmit: function (e) {
                   



    //        //        //return false;
    //        //    }
    //        //});
    //    }
    //},
    bindNewsletterForm() {
        //if (document.getElementById('newsletterform') != null) {

        //    var validator = new VanillaValidator({
        //        container: '#newsletterform',
        //        validationBy: 'onclick',
        //        messages: errormessages,
        //        novalidateHTML5: false,
        //        validateOnFieldChanges: true,
        //        callbacks: {
        //            error: function (element) {
        //                var postop = document.getElementById('newsletterform').querySelector('.msg-error').getBoundingClientRect().top + window.scrollY - 200;
        //                window.scrollTo({ top: postop, behavior: "smooth" });
        //            }
        //        },
        //        onFormSubmit: function (e) {
        //            window.showLoading();
        //            if (currentEnquiryRequest === true) {
        //                return true;
        //            }
        //            currentEnquiryRequest = true;

        //            // Formulardaten in ein JSON-Objekt umwandeln
        //            var formData = new FormData(document.getElementById("newsletterform"));
        //            const data = {};

        //            formData.forEach((value, fullKey) => {
        //                const keys = [];
        //                const keyPattern = /[^\[\]]+/g;
        //                let match;
        //                while ((match = keyPattern.exec(fullKey)) !== null) {
        //                    keys.push(match[0]);
        //                }

        //                let current = data;
        //                for (let i = 0; i < keys.length; i++) {
        //                    const key = keys[i];
        //                    const nextKey = keys[i + 1];
        //                    const isLast = i === keys.length - 1;

        //                    if (isLast) {
        //                        if (key in current) {
        //                            if (Array.isArray(current[key])) {
        //                                current[key].push(value);
        //                            } else {
        //                                current[key] = [current[key], value];
        //                            }
        //                        } else {
        //                            current[key] = value;
        //                        }
        //                    } else {
        //                        if (!current[key]) {
        //                            current[key] = /^\d+$/.test(nextKey) ? [] : {};
        //                        }
        //                        current = current[key];
        //                    }
        //                }
        //            });

        //            website.formData = data;


        //            var sendRequest = (payload) => {
        //                axios.post('/api/json/sendnewsletter',
        //                    JSON.stringify(payload),
        //                    {
        //                        headers: {
        //                            'Content-Type': 'application/json'
        //                        }
        //                    }
        //                ).then((res) => {
        //                    if (res.data == "True") {
        //                        if (website.hasTagmanager) {
        //                            window.gaPushEvent("form", 'newsletter', 'sent');
        //                        }
        //                        document.getElementById("newsletterform").classList.add("d-none");
        //                        document.getElementById("newsletterform-success").classList.remove("d-none");
        //                        document.getElementById("newsletterform-error").classList.add("d-none");
        //                    } else {
        //                        document.getElementById("newsletterform-error").classList.remove("d-none");
        //                    }
        //                }).catch((error) => {
        //                    document.getElementById("newsletterform-success").classList.add("d-none");
        //                    document.getElementById("newsletterform-error").classList.remove("d-none");
        //                }).finally(() => {
        //                    window.hideLoading();
        //                    currentEnquiryRequest = false;
        //                });
        //            };

        //            // Wenn reCAPTCHA aktiv → Token holen
        //            if (website.googlerecaptcha_active === true) {
        //                loadRecaptchaIfNeeded(website.googlerecaptcha_pkey)
        //                    .then(grecaptcha => grecaptcha.execute(website.googlerecaptcha_pkey, { action: 'submit' }))
        //                    .then(token => {
        //                        data["grecaptcharesponse"] = token;
        //                        sendRequest(data);
        //                    })
        //                    .catch(error => {
        //                        consolelog("reCAPTCHA Fehler:" + error);
        //                        document.getElementById("newsletterform-error").classList.remove("d-none");
        //                        window.hideLoading();
        //                        currentEnquiryRequest = false;
        //                    });
        //            } else {
        //                // Ohne reCAPTCHA
        //                sendRequest(data);
        //            }

        //            return false; // VanillaValidator soll nicht das Formular absenden
        //        }
        //    });
        //}
    },
    teaseractive(id) {
        teasersswiper[0].swiper.slideTo(id);
    },
    isActiveNav(id) {
        return this.app.currentNavId != undefined && this.app.currentNavId == id;
    },
    navactive(id) {
        this.app.currentNavId = id;
        window.updateBackgrounds();
    },
    showamenities(event) {
        var parent = event.target.closest('.roomcategory');
        if (parent.classList.contains("show-amenities")) {
            parent.classList.remove("show-amenities")
        } else {
            parent.classList.add("show-amenities")
        }
    },
    ispageinit() {
        return this.app.pageinit;
    },
    ismenuActive() {
        return this.app.menuActive;
    },
    isscrolled() {
        return this.app.scrolled;
    },
    isActiveTeaser(id, sliderId) {
        return this.app.currentTeaserId != undefined && this.app.currentTeaserId[sliderId] != null && this.app.currentTeaserId[sliderId] == id;
    },
    // ================= Menu
    bindCurrentNavigation() {
        const normalizeUrl = value => {
            try {
                const url = new URL(value, window.location.origin);
                const path = (url.pathname.replace(/\/+$/, '') || '/').toLocaleLowerCase();
                const query = Array.from(url.searchParams.entries())
                    .map(([key, queryValue]) => [key.toLocaleLowerCase(), queryValue.toLocaleLowerCase()])
                    .sort(([keyA, valueA], [keyB, valueB]) => {
                        const keyComparison = keyA.localeCompare(keyB);
                        return keyComparison || valueA.localeCompare(valueB);
                    });
                const search = new URLSearchParams(query).toString();
                return search ? `${path}?${search}` : path;
            } catch (error) {
                return '';
            }
        };

        const currentUrl = normalizeUrl(window.location.href);
        document.querySelectorAll('.navbar .hover-menu .nav-link').forEach(link => {
            link.classList.remove('current');
            if (normalizeUrl(link.href) !== currentUrl) return;

            link.classList.add('current');
            const parent = link.closest('.nav-item.haschilds');
            if (!parent) return;

            parent.classList.add('active');
            parent.querySelector(':scope > .mainnavitem')?.setAttribute('aria-expanded', 'true');
        });
    },
    triggerMenu() {
        this.app.menuActive = !this.app.menuActive;
        if (this.app.menuActive) {
            if (document.body.classList.contains("nav-active") == false) {
                document.body.classList.add("nav-active");
            }


        } else {
            if (document.body.classList.contains("nav-active")) {
                document.body.classList.remove("nav-active");
            }

        }
    },
    // ================= TriggerSubMenu
    triggerSubMenu(event) {
        event.preventDefault();
        const item = event.currentTarget.closest('.nav-item.haschilds');
        if (!item) return false;

        const navigation = item.closest('.navbar-nav');
        const open = item.classList.contains('submenu-open');
        document.querySelectorAll('.nav-item.haschilds.submenu-open').forEach(otherItem => {
            otherItem.classList.remove('submenu-open');
            otherItem.querySelector(':scope > .mainnavitem')?.setAttribute('aria-expanded', 'false');
        });

        if (!open) {
            item.classList.add('submenu-open');
            event.currentTarget.setAttribute('aria-expanded', 'true');
            navigation?.classList.add('has-open-submenu');
        } else {
            navigation?.classList.remove('has-open-submenu');
        }
        return false;
    },
    //inputChange(evt) {
    //    try {
    //        if (evt.target.id == "childs") {
    //            setTimeout(function () {
    //                this.bindForm();
    //            }, 700)
    //        }
    //        if (evt.target.value.length > 0) {
    //            if (!evt.target.classList.contains("active")) {
    //                evt.target.classList.add("active");
    //            }
    //            // Special for DateRangepicker
    //            if (evt.target.id == "enquiryform-arrival") {
    //                var enquirydeparture = document.getElementById("enquiryform-departure");
    //                if (enquirydeparture != undefined && !enquirydeparture.classList.contains("active")) {
    //                    enquirydeparture.classList.add("active");
    //                }
    //            }
    //        } else {
    //            if (evt.target.classList.contains("active")) {
    //                evt.target.classList.remove("active");
    //            }

    //            // Special for DateRangepicker
    //            if (evt.target.id == "enquiryform-arrival") {
    //                var enquirydeparture = document.getElementById("enquiryform-departure");
    //                if (enquirydeparture != undefined && enquirydeparture.classList.contains("active")) {
    //                    enquirydeparture.classList.remove("active");
    //                }
    //            }
    //        }
    //    } catch (ex) {

    //    }
    //},
    //addroom(evt) {
    //    this.app.enquiryroomscount++;
    //},
    //removeroom(evt) {
    //    this.app.enquiryroomscount--;
    //},
    scrollTo(id) {
        var postop = document.getElementById(id).getBoundingClientRect().top + window.scrollY - 200;
        window.scrollTo({ top: postop, behavior: "smooth" });
    },
    mounted() {

        consolelog("PetiteVue mounted");
        // Main
        this.bindCurrentNavigation();
        this.bindMenuScroll();
        this.bindSrc();
        //this.app.locomotivescroll();
        this.bindswiper();
        this.binddataclick();
        this.bindgaq();
        //this.app.bindparallax();
        this.bindstoerer();
        this.scrollOnLoad();
        this.sameheight();
        this.bindreadmore();
        this.initAos();
        this.bindaccordions();

        this.bindCounters();
        this.bindViewportVideos();
        this.bindPortfolioFilter();
        this.bindEstateGallery();
        // Enquiry
        //this.bindForm();
        //this.bindDatepicker();

        //Newsletter
        //this.bindNewsletterForm();

        // Postcard
        //this.app.bindPostcardForm();
        this.app.pageinit = true;

        //if (website.price != null) {
        //    var myTabella = new Tabella(document.getElementById('pricetable'), website.price);
        //}

        if (document.querySelector('.nav-item.current') != null) {
            this.app.currentNavId = document.querySelector('.nav-item.current').dataset.trigger;
        }

        if (document.querySelector("#enquiryform")) {
            // Lädt enquiry.module.js nur, wenn das Formular existiert
            import("./enquiry.js").then((m) => {
                consolelog("enquiry Modules");
                m.enquiryModule(this); // Zugriff auf die Module-Funktion
                this.initEnquiry();         // Zugriff auf andere exportierte Funktionen
                this.bindForm();
                this.bindDatepicker();
            });
        }

    },
    // root scope for app two
}).mount('#app')


//import './features/aosAnimations.js';
